/* eslint-disable */

// 对应 lily.format.js，格式化方法。
import getMethods from './methods'
export default {
  install: function (Vue, options) {
    const methods = getMethods.call(Vue.prototype)
    Vue.prototype.$_format = {
      ...methods,
      /*
       * 常量
       */
      AREA_CODE: {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外"
      },
      MONEY_NUMS: new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"),
      MONEY_DIGITS: new Array("", "拾", "佰", "仟"),
      MONEY_BIGUNITS: new Array("", "万", "亿", "万亿", "仟兆"),
      MONEY_SHOWNAME: new Array("分", "角", "圆"),

      MONEY_POSTFIX: "整",
      DATETIME_FORMAT: "yyyymmddhhmiss",
      TIME_FORMAT: "hhmiss",
      TIME_FORMAT_DISPLAY: "hh:mi:ss",
      DATE_FORMAT: "yyyymmdd",
      MONTH_FORMAT: "yyyymm",
      DATE_FORMAT_DISPLAY: "yyyy年mm月dd日",
      MONTH_FORMAT_DISPLAY: "yyyy年mm月底",
      DATE_FORMAT_SHORT: "yyyy-mm-dd",
      /**
       * 正则表达式定义
       */
      REGEXP_INTEGER: new RegExp(/^[0-9]+$/),
      REGEXP_FLOAT: new RegExp(/^([0-9]+(\.+))[0-9]+$/),
      REGEXP_DECIMAL: new RegExp(/^([0-9]+(\.?))?[0-9]+$/),
      REGEXP_MONEY: new RegExp(/^[0-9]*\.?[0-9]{0,2}$/),
      REGEXP_COMMA: new RegExp('\,', ["g"]),
      REGEXP_DOT: new RegExp('\\.', ["g"]),
      REGEXP_EMAIL: new RegExp(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/),
      REGEXP_DATE: new RegExp(/(yyyy|mm|dd|hh|mi|ss|ms)/gi),
      REGEXP_PHONE: new RegExp(/^((0\d{2,3})-)(\d{7,8})(-(\d{1,6}))?$/),
      REGEXP_MOBILE: new RegExp(/^(1[1-9])[0-9]{9}$/),
      REGEXP_CONNECTION: new RegExp(/^([0-9]+(\-?))?[0-9]+$/),
      REGEXP_NEGSIGN: new RegExp('\-', ["g"]),
      REGEXP_ONLYNUMORSYMBOL: new RegExp(/[\a-\z\A-\Z\u4E00-\u9FA5]/),
      REGEXP_SPECIAL_CHAR: new RegExp(/[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/),
      REGEXP_ISDATE: new RegExp(/(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29)/)
    }
  }
}
